import Quill from 'quill';

const Embed = Quill.import('blots/embed');

class EmojiBlot extends Embed {
    static blotName = 'emoji-inline';

    static tagName = 'span';

    static className = 'ql-emojiblot';
  
    static create(value: any) {
      const node = super.create() as HTMLElement;
      
      const id = typeof value === 'object' ? value.id : value;
      const native = typeof value === 'object' ? value.native : '';
  
      node.setAttribute('data-name', id);
      node.setAttribute('data-native', native);
      node.setAttribute('contenteditable', 'false');
  
      const outerSpan = document.createElement('span');
      outerSpan.setAttribute('contenteditable', 'false');
      
      const innerSpan = document.createElement('span');
      innerSpan.className = `ap ap-${id}`;
      innerSpan.innerText = native;
      
      outerSpan.appendChild(innerSpan);
      node.appendChild(outerSpan);
      
      return node;
    }

    static formats(node: HTMLElement) {
      return {
        id: node.getAttribute('data-name'),
        native: node.getAttribute('data-native')
      };
    }
  
    static value(node: HTMLElement) {
      return {
        id: node.getAttribute('data-name'),
        native: node.getAttribute('data-native') || node.innerText
      };
    }
  }

Quill.register(EmojiBlot, true);

export default Quill;